import {Text} from 'native-base';
import {ReactNode} from 'react';

export interface BodyTextProps {
  children: ReactNode | string;
  bold?: boolean;
  fontSize: string;
  color?: string;
}

const BodyText: React.FC<BodyTextProps> = (props) => {
  const {children, bold = false, fontSize, color} = props;
  return (
    <Text
      color={color ?? 'tuna'}
      fontSize={fontSize}
      fontFamily="body"
      fontWeight={bold ? 'bold' : 'normal'}
      lineHeight="24px"
    >
      {children}
    </Text>
  );
};

export default BodyText;
